import { InvoiceDetails } from "@/shared/domain";

export const mapInvoice = (invoiceDetails: InvoiceDetails, policyholderId: number): MyBrokerApi.Invoice => {
    return {
        reference: invoiceDetails.paymentDetails.reference,
        amount: invoiceDetails.paymentDetails.amount,
        status: invoiceDetails.paymentDetails.paymentStatus,
        beneficiaryAccount: "",
        balance: 0,
        branch: invoiceDetails.contractDetails.contractBranch,
        contractDescription: invoiceDetails.contractDetails.contractDescription,
        contractId: 0,
        contractName: invoiceDetails.contractDetails.contractReference,
        id: invoiceDetails.invoiceId,
        date: invoiceDetails.receiptDate,
        links: null,
        policyHolder: invoiceDetails.policyHolder,
        policyholderId,
        structuredCommunication: invoiceDetails.paymentDetails.structurePaymentReference,
    };
};
